/**
 * API Configuration
 * Uses PHP backend endpoints that run on same server as React
 * PHP files handle SOAP communication with broker
 */

const baseUrl = window.location.origin;

console.log('🔧 API Configuration: Using PHP backend at', baseUrl);

export const apiConfig = {
  baseUrl,
  endpoints: {
    session: `${baseUrl}/api.php?endpoint=booking/session`,
    search: `${baseUrl}/api.php?endpoint=booking/search`,
    cities: `${baseUrl}/api.php?endpoint=booking/cities`,
    reserveSeats: `${baseUrl}/api.php?endpoint=booking/reserve-seats`,
    addPassenger: `${baseUrl}/api.php?endpoint=booking/add-passenger`,
    calculateFare: `${baseUrl}/api.php?endpoint=booking/calculate-fare`,
    initiatePayment: `${baseUrl}/api.php?endpoint=booking/initiate-payment`,
    logPayment: `${baseUrl}/api.php?endpoint=booking/log-payment`,
    confirm: `${baseUrl}/api.php?endpoint=booking/confirm`,
    paymentCallback: `${baseUrl}/api.php?endpoint=booking/payment-callback`,
    paymentStatus: (globalRefId: string) => `${baseUrl}/api.php?endpoint=booking/payment-status&id=${globalRefId}`,
    paymentReferences: (globalRefId: string) => `${baseUrl}/api.php?endpoint=booking/payment-references&id=${globalRefId}`,
    confirmation: (globalRefId: string) => `${baseUrl}/api.php?endpoint=booking/confirmation&id=${globalRefId}`,
    health: `${baseUrl}/api.php?endpoint=booking/health`,
  },
};
